export default "__VITE_ASSET__d42cc1cd__"